import PropTypes from 'prop-types'
import { AdasTextField } from './AdasTextField'

export const AdasPhoneField = ({
  value,
  onChange,
  label,
  disabled,
  error,
  // isValid is the legacy prop — map it to error/helperText for backward compat
  isValid,
  helperText,
  required,
  name,
  id,
  ...props
}) => {
  const hasError = error !== undefined ? error : isValid === false
  const resolvedHelperText =
    helperText !== undefined ? helperText : isValid === false ? 'Phone number must be in the format (123) 456-7890' : ''

  return (
    <AdasTextField
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
      error={hasError}
      helperText={resolvedHelperText}
      required={required}
      name={name}
      id={id}
      type='tel'
      inputProps={{ maxLength: 14 }}
      fullWidth
      {...props}
    />
  )
}

AdasPhoneField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  isValid: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string
}
